import { CONFIG } from './config';

interface TurnstileApi {
  render(el: HTMLElement | string, opts: Record<string, unknown>): string;
  reset(widgetId?: string): void;
  getResponse(widgetId?: string): string | undefined;
  remove(widgetId: string): void;
}

declare global {
  interface Window {
    turnstile?: TurnstileApi;
    __finavestTsReady?: () => void;
  }
}

let loadPromise: Promise<TurnstileApi> | null = null;

function loadTurnstile(): Promise<TurnstileApi> {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (loadPromise) return loadPromise;
  loadPromise = new Promise<TurnstileApi>((resolve, reject) => {
    window.__finavestTsReady = () => resolve(window.turnstile!);
    const s = document.createElement('script');
    s.src =
      'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=__finavestTsReady';
    s.async = true;
    s.defer = true;
    s.onerror = () => reject(new Error('Turnstile konnte nicht geladen werden.'));
    document.head.appendChild(s);
  });
  return loadPromise;
}

export interface TurnstileWidget {
  /** Current solved token, or '' if not yet solved. */
  getToken(): string;
  reset(): void;
}

/** Lazily render a Turnstile widget into `container`. Safe to call once per container. */
export async function renderTurnstile(
  container: HTMLElement,
  action: string,
): Promise<TurnstileWidget> {
  const api = await loadTurnstile();
  container.innerHTML = '';
  const id = api.render(container, {
    sitekey: CONFIG.turnstileSitekey,
    // Follows the widget theme (embed.ts sets data-theme from ?theme=dark).
    theme: document.documentElement.dataset.theme === 'dark' ? 'dark' : 'light',
    action,
  });
  return {
    getToken: () => api.getResponse(id) ?? '',
    reset: () => api.reset(id),
  };
}
